// AYA Multiservice — Écran 4 : traitement simulé de la transaction.
import React from "react";
import { Check, X, Smartphone, HelpCircle } from "lucide-react";
import { BrandLogo } from "./BrandLogo";

const STEP_LABELS = {
  created: { t: "Demande créée", s: "Commande enregistrée dans la simulation" },
  payment: { t: "Paiement simulé", s: "Aucun débit réel n'a lieu" },
  recharge: { t: "Recharge simulée", s: "Transmission simulée à l'opérateur" },
  result: { t: "Résultat confirmé", s: "Confirmation du traitement simulé" },
};

export default function ProcessingStep({ catalog, order }) {
  const op = (catalog?.operators || []).find((o) => o.id === order?.operator_id);
  const events = order?.events || [];
  const timeFr = (iso) => (iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "");

  return (
    <div className="ms-proc" data-testid="ms-processing-step">
      <div className="ms-proc-illus">
        <span className="ms-spin-ring" />
        <span className="ms-proc-center">{op ? <BrandLogo brand={op.brand} size={54} /> : <Smartphone size={28} color="#059669" />}</span>
      </div>
      <h2>Traitement de votre recharge</h2>
      <p>Nous simulons le traitement de votre opération.</p>

      <div className="ms-timeline" data-testid="ms-timeline">
        {events.map((ev, i) => {
          const meta = STEP_LABELS[ev.step] || { t: ev.label, s: "" };
          const cls = ev.status === "done" ? "done" : ev.status === "failed" ? "failed" : ev.status === "unknown" ? "unknown" : i === events.findIndex((e) => e.status === "pending") ? "active" : "";
          return (
            <div className="ms-step" key={ev.step} data-testid={`ms-step-${ev.step}`}>
              <span className="ms-step-rail">
                <span className={`ms-step-dot ${cls}`}>
                  {ev.status === "done" && <Check size={13} color="#fff" strokeWidth={3} />}
                  {ev.status === "failed" && <X size={13} color="#fff" strokeWidth={3} />}
                  {ev.status === "unknown" && <HelpCircle size={13} color="#fff" strokeWidth={3} />}
                </span>
                {i < events.length - 1 && <i />}
              </span>
              <span className="ms-step-body">
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <span className="ms-step-title">{ev.label || meta.t}</span>
                  <span className="ms-step-time">{timeFr(ev.at)}</span>
                </div>
                <div className="ms-step-sub">{ev.status === "pending" ? "En attente" : meta.s}</div>
              </span>
            </div>
          );
        })}
      </div>
      <p style={{ fontSize: 10.5, color: "#8AA193", marginTop: 8 }}>Vous pouvez quitter cet écran : la commande reste visible dans l'historique.</p>
    </div>
  );
}
